<template>
  <div class="shop ">
    <!-- <nav-header @getTelPhone="getTelPhone" @getSearch="getSearch" :value1="searchText"></nav-header> -->
    <div class="nav">
      <div>
        <div class="nav_logo">
          <a class="nav_href">
            <img src="../../assets/images/whitelogo.png" alt="">
          </a>
        </div>
        <div class="nav-phone-box"><a class="nav_phone" @click="getTelPhone"></a></div>
        <div class="nav_search">
          <input class="nav_search_content" v-model="searchText" @keyup.enter="search()" type="text"
                 placeholder="基因调控生命的进程">
          <input class='nav_search_submit' @click="search()" type="submit" value="">
        </div>
      </div>
    </div>
    <div class="sub_title">
      <div class="sub-right">
        <ul>
          <li class="kind-item" v-for="(item ,index ) in navkindList" :key="index">
            <a :class="kindName == index ? 'active' : ''" href="javascript:;" @click="kindInfo(index,1,1)">{{classify}}{{item}}</a>
          </li>
        </ul>
      </div>
    </div>
    <cube-scroll ref="scroll" :data="items" :options="options" @pulling-down="onPullingDown" @pulling-up="onPullingUp"
                 class="page_scroll">
      <div class="scroll-box">
        <div class="sub—content">
          <!--          普通用户
          <ul v-show="isActive == 0" class="ul1">
            <li class="noDataTip notice" v-if="kindList.length == 0">
              <dl>
                <dt></dt>
                <dd>暂无数据</dd>
              </dl>
            </li>
            <li v-for="(item, index) in kindList" :key="index">
              <router-link :to="{ name: 'shopDetail', params: { 'commodity_id': item.commodity_id }}">
                <div class="sub-hot-list" :style="`background-image:url(${item.home_page})`">
                  <div class="sub-hot-list-left">
                    <h5 style="color: #fff">{{item.title}}</h5>
                    <p class="sub-con" style="color: #fff">{{item.title1}}</p>
                    <p class="sub-pay" @click.stop="payGood(item.commodity_id)"><span>立即购买</span><span
                      style="color: #fff">￥{{item.money}}</span></p>
                  </div>
                  <div class="sub-hot-list-img">
                    <img :src="item.home_page1" alt="">
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
-->
          <!--          业务员-->
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <ul v-show="isActive == 1" class="ul2">
              <li class="noDataTip notice" v-if="hotList.length == 0">
                <dl>
                  <dt></dt>
                  <dd>暂无数据</dd>
                </dl>
              </li>

              <li v-for="(item, index) in hotList" :key="index">
                <el-checkbox :label="item.commodity_id"></el-checkbox>
                <router-link :to="{ name: 'shopDetailywy', params: { 'commodity_id': item.commodity_id }}">
                  <div class="sub-hot-list" :style="`background-image:url(${item.home_page})`">
                    <!-- :style="`background-image:url(${item.home_page})`" -->
                    <div class="sub-hot-list-left">
                      <h5 style="color: #fff">{{item.title}}</h5>
                      <p class="sub-con" style="color: #fff">{{item.title1}}</p>
                      <p class="sub-pay" @click="payGood(item.commodity_id)"><span>立即购买</span>
                        <span style="color: #fff">￥{{item.money}}</span>
                      </p>
                    </div>
                    <!--
                    <div class="sub-hot-list-img" >
                      <img :src="item.home_page1" alt="">
                    </div>
                    -->
                  </div>
                </router-link>
              </li>
            </ul>
          </el-checkbox-group>

          <!--医生
          <ul v-show="isall == 2" class="ul3">
            <li class="noDataTip notice" v-if="allList.length == 0">
              <dl>
                <dt></dt>
                <dd>暂无数据</dd>
              </dl>
            </li>
            <li v-for="(item, index) in allList" :key="index">
              <router-link :to="{ name: 'shopDetailywy', params: { 'commodity_id': item.commodity_id }}">
                <div class="sub-hot-list" :style="`background-image:url(${item.home_page})`">
                  :style="`background-image:url(${item.home_page})`"
                  <div class="sub-hot-list-left">
                    <h5 style="color: #fff">{{item.title}}</h5>
                    <p class="sub-con" style="color: #fff">{{item.title1}}</p>
                    <p class="sub-pay" @click="payGood(item.commodity_id)"><span>立即购买</span><span style="color: #fff">￥{{item.money}}</span>
                    </p>
                  </div>
                  <div class="sub-hot-list-img">
                    <img :src="item.home_page1" alt="">
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
-->
        </div>
      </div>
    </cube-scroll>
    <footer-bar :sy='1' v-show="type == 0"></footer-bar>

    <div class="com-foot1" v-show="type == 2">
      <div class="dn-fr">
        <el-button type="primary" round @click="buy1">立即购买</el-button>
      </div>
    </div>

  </div>
</template>
<script>
   import navHeader from '../../components/nav/nav1'
   import footerBar from '../../components/footer'
   import Vue from 'vue';
   import {Checkbox, CheckboxGroup} from 'vant';

   Vue.use(Checkbox);
   Vue.use(CheckboxGroup);


   export default {

      name: 'shop',
      data() {
         return {
            type: this.$route.params.type, //用户角色类型
            options: {
               pullUpLoad: {
                  threshold: 60,
                  txt: {
                     more: '加载更多',
                     noMore: '没有更多了'
                  }
               },
               pullDownRefresh: {
                  threshold: 60,
                  txt: '刷新成功'
               }
            },
            user_id: localStorage.getItem('user_id'),
            isall: false,
            isShowList: false,
            isActive: 1, //类别显示状态， 0新品，1热销
            pageNum: 1,
            allpage: null,
            hotList: [], //热销
            kindList: [], //分类 新品
            items: [],
            allList: [],
            navkindList: [
               '全部',
               '检测类',
               '保存类',
               '保管类',
               '检测卡'

            ],
            kindName: 1, //分类记录名称
            isSearch: false, //是否搜索
            searchText: '', //搜索内容
            classify: '',
            // 全选
            checkAll: false,
            cityOptions: [],
            checkedCities: [],
            isIndeterminate: false,
            salesman_id: '',
         }
      },
      mounted() {
         // this.$loading.show()
         console.log('user_id:', this.user_id)

      },
      created() {
         this.getSearch('', '', 1, 1)
         console.log('type2:', this.type)
         this.salesman_id = this.$utils.getUrlKey('salesman_id')

      },
      methods: {
         // 按钮选择
         handleCheckedCitiesChange(value) {
            console.log(value)
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cityOptions.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cityOptions.length;
         },
         // 立即购买
         buy1() {
            console.log(this.checkedCities)

            if (localStorage.getItem('type') == 1) {
               this.$router.push({
                  name: 'payGoods',
                  params: {'commodity_id': this.checkedCities[0], 'salesman_id': this.salesman_id}
               })
            } else if (localStorage.getItem('type') == 2) {
               console.log(this.checkedCities.length)
               if (this.checkedCities.length == 0) {

                  this.$message({
                     message: '选择不能为空',
                     type: 'warning'
                  });
               } else {

                  localStorage.setItem('commodityIdList', JSON.stringify(this.checkedCities));
                  // localStorage.setItem('commodityIdList',this.checkedCities);

                  this.$router.push({
                     name: 'paygoodsywy',
                     // params: {commodityIdList: this.checkedCities}
                     // query: {commodityIdList: this.checkedCities}
                  })

               }

            } else {
              /*
               this.$router.push({
                  name: 'login'
               })
               */
              window.location.href = this.$store.state.windowhref
            }


         },
         search() {
            let _this = this;
            _this.getSearch(_this.searchText, _this.kindName, _this.pageNum = 1, 1)
         },
         /**
          * 产品分类  1 基因检测类,2 基因保存类,3 基因代保管类 4 检测卡
          */
         // 搜索
         getSearch(value, kindName = '', pageNum = 1, type = 1) {
            this.isSearch = true
            this.searchText = value
            let _this = this
            this.$http.api.shopywy({
               page: pageNum,
               size: 1000,
               name: this.searchText ? this.searchText : '',
               classify: this.kindName == 0 ? '' : this.kindName,
               commodityType: '',
               user_id: _this.user_id
            }).then(result => {
               console.log('result1:', result)
               _this.allpage = Math.ceil(result.total / 1000)
               let data = result
               if (type === 1) {
                  if (_this.isActive == 0) {
                     _this.kindList = [...data]
                  } else if (_this.isActive == 1) {
                     _this.hotList = [...data]

                     _this.hotList.forEach(function (item, index) {
                        _this.cityOptions.push(item.commodity_id)
                     });

                  }
                  _this.pageNum = 2
                  _this.$refs.scroll.forceUpdate()

               } else {
                  if (data.length > 0 && _this.pageNum < _this.allpage) {
                     if (_this.isActive == 0) {
                        _this.kindList = _this.kindList.concat(data)
                     } else if (_this.isActive == 1) {
                        _this.hotList = _this.hotList.concat(data)
                        _this.hotList.forEach(function (item, index) {
                           _this.cityOptions.push(item.commodity_id)
                        });
                     }
                     //  _this.kindList = _this.kindList.concat(data)
                     _this.pageNum = _this.pageNum + 1
                     _this.$refs.scroll.forceUpdate()
                  }
               }

            })
            if (_this.pageNum > _this.allpage) {
               setTimeout(function () {
                  _this.$refs.scroll.forceUpdate()
               }, 300)
            }

            if (_this.pageNum > _this.allpage) {
               setTimeout(function () {
                  _this.$refs.scroll.forceUpdate()
               }, 300)
            }
         },
         showkindList() {
            this.isShowList = !this.isShowList
         },
         // 点击分类
         kindInfo(name, pageNum, type) {
            this.isSearch = false
            // this.$loading.show()
            this.isall = true
            this.isShowList = false
            let _this = this
            this.kindName = name;
            this.checkedCities = []
            console.log('checkedCities:', this.checkedCities)
            if (this.type == 0 || this.type == 2) {
               this.$http.api.shopywy({
                  page: pageNum,
                  size: 1000,
                  name: this.searchText ? this.searchText : '',
                  classify: name == 0 ? '' : name,
                  commodityType: '',
                  user_id: _this.user_id
               }).then(result => {
                  console.log('result:', result)
                  // this.$loading.hide()
                  _this.allpage = Math.ceil(result.total / 1000)
                  let data = result
                  if (type === 1) {
                     _this.allList = [...data]
                     _this.$refs.scroll.forceUpdate()
                     _this.pageNum = 2
                     if (_this.isActive == 0) {
                        _this.kindList = _this.allList
                     } else if (_this.isActive == 1) {
                        _this.hotList = _this.allList
                        _this.hotList.forEach(function (item, index) {
                           _this.cityOptions.push(item.commodity_id)
                        });
                     }
                  } else {
                     if (data.length > 0 && _this.pageNum < _this.allpage) {
                        _this.allList = _this.allList.concat(data)
                        _this.pageNum = _this.pageNum + 1
                        if (_this.isActive == 0) {
                           _this.kindList = _this.allList
                        } else if (_this.isActive == 1) {
                           _this.hotList = _this.allList
                        }
                        _this.hotList.forEach(function (item, index) {
                           _this.cityOptions.push(item.commodity_id)
                        });
                        _this.$refs.scroll.forceUpdate()
                     }
                  }
               })
               if (_this.pageNum > _this.allpage) {
                  setTimeout(function () {
                     _this.$refs.scroll.forceUpdate()
                  }, 300)
               }
            } else if (this.type == 1) {
               this.$http.api.recommendShop({
                  page: pageNum,
                  size: 1000,
                  name: this.searchText ? this.searchText : '',
                  classify: name == 0 ? '' : name,
                  commodityType: ''
               }).then(result => {

                  // this.$loading.hide()
                  _this.allpage = Math.ceil(result.total / 1000)
                  let data = result.rows
                  if (type === 1) {
                     _this.allList = [...data]
                     _this.$refs.scroll.forceUpdate()
                     _this.pageNum = 2
                     if (_this.isActive == 0) {
                        _this.kindList = _this.allList
                     } else if (_this.isActive == 1) {
                        _this.hotList = _this.allList
                        _this.hotList.forEach(function (item, index) {
                           _this.cityOptions.push(item.commodity_id)
                        });
                     }
                  } else {
                     if (data.length > 0 && _this.pageNum <= _this.allpage) {
                        _this.allList = _this.allList.concat(data)
                        _this.pageNum = _this.pageNum + 1
                        if (_this.isActive == 0) {
                           _this.kindList = _this.allList
                        } else if (_this.isActive == 1) {
                           _this.hotList = _this.allList
                           _this.hotList.forEach(function (item, index) {
                              _this.cityOptions.push(item.commodity_id)
                           });
                        }
                        _this.$refs.scroll.forceUpdate()
                     }
                  }
                  // console.log(allList)
               })
               if (_this.pageNum > _this.allpage) {
                  setTimeout(function () {
                     _this.$refs.scroll.forceUpdate()
                  }, 300)
               }
            }
         },
         // 立即购买
         payGood(shopId) {
            this.$router.push({
               name: 'payGoods',
               query: {
                  'commodity_id': shopId
               }
            })
         },
         onPullingDown() {
            // this.isLoading = false
            let _this = this
            _this.getSearch(_this.searchText, _this.kindName, 1, 1)
         },
         onPullingUp() {
            let _this = this
            setTimeout(function () {
               if (this.isSearch) {
                  _this.getSearch(_this.searchText, _this.kindName, _this.pageNum, 2)
               } else {
                  _this.getSearch(_this.searchText, _this.kindName, _this.pageNum, 2)
               }
            }, 800)
         },
         getTelPhone() {
            // 点击电话弹窗
            this.$createDialog({
               type: 'confirm',
               // icon: 'cubeic-alert',
               title: '4006-878-036',
               // content: '我是内容',
               confirmBtn: {
                  text: '通话',
                  active: true,
                  disabled: false,
                  href: 'tel:4006-878-036'
               },
               cancelBtn: {
                  text: '取消',
                  active: false,
                  disabled: false,
                  href: 'javascript:;'
               },
               onConfirm: () => {
                  window.location.href = 'tel:4006-878-036'
               },
               onCancel: () => {
               }
            }).show()
         }
      },
      components: {
         navHeader,
         footerBar
      }
   }
</script>
<style lang="less">
  .el-checkbox__label {
    display: none !important;
  }


  .com-bot1 {
    padding-bottom: 1.3rem;
  }

  .el-checkbox__inner {
    transform: scale(1.4);
  }
</style>
<style lang="less" scoped>

  .nav {
    width: 100%;
    // height: 40px;
    background: #60B0E3;
    line-height: 40px;
    padding: 16px 15px 16px;
    box-sizing: border-box;
    font-size: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    .nav_logo {
      float: left;
      width: 40px;
      height: 20px;
      padding-top: 2px;
      margin-right: 10px;

      .nav_href {
        width: 100%;
        display: inline-block;

        img {
          width: 100%;
        }
      }
    }

    .nav_search {
      // width: 80%;
      height: 28px;
      // height: 30px;
      line-height: 28px;
      // line-height: 30px;
      border: none;
      background: #fff;
      // margin: auto;
      // float: left;
      border-radius: 15px;
      overflow: hidden;
      position: relative;

      .nav_search_content {
        width: 100%;
        height: 28px;
        line-height: 28px;
        padding-left: 18px;
        font-size: 12px;
        float: left;
        box-sizing: border-box;
        color: #333;
      }

      .nav_search_submit {
        width: 30px;
        height: 28px;
        background: url(../../assets/images/ys1.png) center center no-repeat;
        -webkit-background-size: 19px auto;
        border: none;
        z-index: 5;
        cursor: pointer;
        -webkit-background-size: 15px auto;
        background-size: 15px auto;
        position: absolute;
        right: 0;
      }
    }

    .nav-phone-box {
      width: 35px;
      // margin-left: 5px;
      float: right;
      padding-top: 2px;

      .nav_phone {
        display: block;
        background: url('../../assets/images/ytel3.png') center center no-repeat;
        -webkit-background-size: cover;
        background-size: cover;
        width: 24px;
        height: 24px;
        margin: 0 auto;
        margin-right: 0;
      }
    }
  }

  .page_scroll {
    /* width: 100%; */
    position: absolute;
    top: 91px;
    left: 0;
    bottom: 0px;
    height: auto;
  }

  .noDataTip {
    width: 100%;
    text-align: center;
  }

  .scroll-box {
    width: 100%;
    position: relative;
    // top: 91px;
    // bottom: 100px;
  }

  .shop {
    width: 100%;

    .sub_title {
      width: 100%;
      height: 30px;
      line-height: 30px;
      color: #999;
      position: relative;
      top: 61px;

      // margin-top: 41px;
      .sub-left {
        width: 20%;
        background: #fff;
        color: #60B0E3;
        font-size: 10px;
        float: left;

        span {
          display: block;
          width: 20px;
          height: 10px;
          margin-top: 8.5px;
          margin-right: 2px;
          color: #60b0e3;
          font-size: 10px;
          background: url(../../assets/images/yi8.png) 10px center no-repeat #fff;
          -webkit-background-size: auto 10px;
          background-size: auto 10px;
          float: left;
          // padding: 0 5px 0 12px;
        }
      }

      .sub-right {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background: rgba(241, 241, 241, .2);
        border-bottom: 1px solid #E0E0E0;
        border-left: 1px solid #E0E0E0;

        ul {
          width: 100%;
          height: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: space-around;

          li {
            height: 100%;
            width: 16.6%;
            padding: 0px 9px;
            box-sizing: border-box;
            border-bottom: 1px solid transparent;
            text-align: center;

            &:first-of-type {
              display: none;
            }
          }

          .active {
            height: 100%;
            display: inline-block;
            border-bottom: 1px solid #60B0E3;
            color: rgba(96, 176, 227, 1);
            font-weight: bold;
            text-decoration: none;
          }
        }
      }
    }

    .allKinds {
      width: 70%;
      height: 50px;
      overflow: scroll;
      position: absolute;
      top: 91px;
      padding: 0 15px;
      box-sizing: border-box;
      z-index: 999;
      background: #FFF;
      border-radius: 0 0 5px 5px;

      .allkinds-list {
        width: 100%;
        padding: 15px 0;

        li {
          // width: 20%;
          padding: 2px 15px;
          border: 1px solid #60B0E3;
          float: left;
          border-radius: 10px;
          margin: 0 3px 5px;
          text-align: center;

          a {
          }
        }
      }
    }

    .upDown-enter-active,
    .upDown-leave-active {
      transition: all .8s;
    }

    .upDown-enter {
      height: 0px;
    }

    .upDown-leave-to

      /* .fade-leave-active below version 2.1.8 */ {
      // opacity: 0;
      height: 0px;
    }

    .sub—content {
      width: 100%;
      padding: 14px 0;
      box-sizing: border-box;
      background: #fff;
      margin-bottom: 55px;

      ul {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;

        li {
          width: 100%;
          margin-bottom: 10px;
          display: flex;
          align-items: center;

          .el-checkbox {
            width: 0.7rem;
          }

          a {
            flex-grow: 1;
          }

          .sub-hot-list {
            // position: relative;
            padding: 24px 100px 13px 18px;
            position: relative;
            color: #fff;
            font-size: 12px;
            border-radius: 5px;
            background: url(../../assets/images/yp9.jpg) no-repeat center center;
            background-size: cover;

            .sub-hot-list-left {
              color: #60B0E3;

              h5 {
                width: 100%;
                height: 32px;
                font-size: 16px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: 15px;
                color: #60B0E3;
              }

              .sub-con {
                // height: 60px;
                width: 100%;
                font-size: 10px;
              }

              .sub-pay {
                margin-top: 18px;

                span:nth-child(1) {
                  width: 66px;
                  height: 24px;
                  line-height: 24px;
                  display: inline-block;
                  color: #60B0E3;
                  background: rgba(255, 255, 255, 1);
                  border-radius: 12px;
                  text-align: center;
                }

                span:nth-child(2) {
                  height: 24px;
                  line-height: 24px;
                  font-size: 18px;
                  display: inline-block;
                  text-align: center;
                  margin-left: 13px;
                }
              }
            }

            .sub-hot-list-img {
              position: absolute;
              top: 27px;
              right: 20px;
              width: 72px;
              height: 73px;
              background-position: center center;
              background-repeat: no-repeat;
              -webkit-background-size: 100% auto;
              background-size: 100% auto;
            }
          }
        }
      }
    }
  }


</style>
